import api from 'data/client';
import { OperationsData } from 'data/types/operations';
import { normalizeOperations } from 'model/operations';

type Props = {
  brandId: string;
  integration: string;
  dateStart: String;
  dateEnd: string;
};

const getOperations = async ({
  brandId,
  integration,
  dateStart,
  dateEnd,
}: Props) => {
  const response = await api.get<OperationsData>(
    `/reporting/operations?brandId=${brandId}&integration=${integration}&dateStart=${dateStart}&dateEnd=${dateEnd}`,
  );
  return normalizeOperations(response.data);
};

export default getOperations;
